import React from "react"
import { Badge } from "react-bootstrap"
import { useTranslation } from "../utils/language"

export default ({ frontmatter }) => {
  const { t } = useTranslation()
  const { institution, degree, field, location, startDate, endDate, tags } = frontmatter

  return (
    <div className="cv-timeline-item">
      <div className="cv-timeline-dot" />
      <div className="cv-timeline-content">
        <div className="cv-timeline-header">
          <div className="cv-timeline-meta">
            <h5>
              {degree}
              <span className="cv-timeline-position"> — {institution}</span>
            </h5>
            <small>
              {location} · {startDate} → {endDate || t("cv.present")}
            </small>
          </div>
        </div>
        {tags && tags.map(tag => (
          <Badge key={tag} pill className="badge-violet mr-1 mb-1">
            {tag}
          </Badge>
        ))}
      </div>
    </div>
  )
}
